import { Spacing } from '@persona-id/design-tokens';
import { FC } from 'react';
import styled from 'styled-components';

import { VersionMetadata, VersionState } from 'dashboard/components-lib/VersionsSection/utils';
import { VersionRow } from 'dashboard/components-lib/VersionsSection/VersionRow';

const VersionsListContainer = styled.div`
  margin-bottom: ${Spacing[2]};
  flex: auto;

  overflow-y: auto;
  overflow-x: hidden;
`;

const StyledMessage = styled.div`
  padding: ${Spacing[5]} ${Spacing[5]};
  color: ${({ theme }) => theme.color.text.secondary};
  font-size: ${({ theme }) => theme.text.paragraph.lgBold.fontSize};
`;

interface VersionsListProps {
  versions: VersionMetadata[];
  currentVersionId: string;
  isFormPristine: boolean;
  formName: string;
  handleAddLocalDraftVersion: () => void;
  handleDiscardDraft: (() => Promise<void>) | null;
  handleSelectVersion: (versionId: string) => void;
  setDescription?: (description: string) => void;
}

export const VersionsList: FC<VersionsListProps> = ({
  versions,
  currentVersionId,
  isFormPristine,
  formName,
  handleAddLocalDraftVersion,
  handleDiscardDraft,
  handleSelectVersion,
  setDescription,
}) => {
  const versionRows = versions
    .filter(({ status }) => status !== VersionState.Archived)
    .map((versionMetadata, idx) => {
      const versionState =
        !isFormPristine && versionMetadata.editable && versionMetadata.status === VersionState.Saved
          ? VersionState.Unsaved
          : versionMetadata.status;
      return (
        <VersionRow
          key={idx}
          version={{
            ...versionMetadata,
            status: versionState,
          }}
          isFirst={idx === 0}
          isLast={idx === versions.length - 1}
          isSelected={versionMetadata.id === currentVersionId}
          formName={formName}
          handleAddLocalDraftVersion={handleAddLocalDraftVersion}
          handleDiscardDraft={handleDiscardDraft}
          handleSelectVersion={handleSelectVersion}
          setDescription={setDescription}
        />
      );
    });

  return (
    <VersionsListContainer role='list' aria-label='Version history'>
      {versionRows.length === 1 ? (
        <StyledMessage>Saved and published changes will appear here.</StyledMessage>
      ) : (
        versionRows
      )}
    </VersionsListContainer>
  );
};
